<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <!-- 顶部打开app -->
      <openAppDialog
        ref="openApp"
        :title="openTitle"
        :shareId="shareId"
        :shareType="shareType"
        :isShow="true"
        @openApp="openApp()"
      />
      <div v-if="!emptyShow" @click="showApp()">
        <div class="banner_container">
          <van-swipe
            :autoplay="5000"
            :loop="true"
            :show-indicators="true"
            @change="swiperChange('img', $event)"
          >
            <div slot="indicator" class="indicator_box">
              {{ imgIndex + 1 }} /
              {{ detailData.cover_img.length }}
            </div>
            <van-swipe-item v-for="(item, index) in detailData.cover_img" :key="index">
              <van-image width="100%" :src="item" fit="contain"></van-image>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="gourmet-conenter">
          <div class="gourmet-title">{{ detailData.name }}</div>
          <div class="gourmet-subtitle">{{ detailData.affiliation }}</div>
          <div class="gourmet-tag">
            <template v-for="(item, index) in detailData.tag">
              <div class="gourmet-tags" :key="index">{{ item }}</div>
            </template>
          </div>
          <div class="gourmet-per-capita" v-if="detailData.consumption">
            <div class="gourmet-per-capita-symbol">￥</div>
            <div class="gourmet-per-capita-price">{{ detailData.consumption }}</div>
            <div class="gourmet-per-capita-unit">/人</div>
          </div>
          <div class="gourmet-conenter-cell" v-if="detailData.open_time">
            <div class="gourmet-conenter-cell-icon">
              <img src="../../assets/images/gourmet/ic_time@2x.png" alt />
            </div>
            <div class="gourmet-conenter-cell-content">
              <div class="gourmet-conenter-cell-title">营业时间 {{ detailData.open_time }}</div>
            </div>
          </div>
          <div class="gourmet-conenter-cell">
            <div class="gourmet-conenter-cell-icon">
              <img src="../../assets/images/gourmet/ic_Path Copy@2x.png" alt />
            </div>
            <div class="gourmet-conenter-cell-content">
              <div class="gourmet-conenter-cell-title">{{ detailData.phone }}</div>
              <div class="gourmet-conenter-cell-right-icon">
                <img src="../../assets/images/gourmet/phone.png" alt />
              </div>
            </div>
          </div>
          <div class="gourmet-conenter-cell">
            <div class="gourmet-conenter-cell-icon">
              <img src="../../assets/images/gourmet/ic_location copy@2x.png" alt />
            </div>
            <div class="gourmet-conenter-cell-content">
              <div class="gourmet-conenter-cell-title">{{ detailData.address }}</div>
              <div class="gourmet-conenter-cell-right-icon">
                <img src="../../assets/images/gourmet/location.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="gourmet-info">
          <div class="gourmet-info-contenter">
            <div class="gourmet-info-title">餐厅介绍</div>
            <div
              class="gourmet-info-introduction"
              :class="{
                                'gourmet-info-introduction-line2':
                                    showMoreDom && !showMore,
                            }"
            >{{ detailData.desc }}</div>
            <div
              class="show-more"
              v-if="showMoreDom"
              @click="showMore = !showMore"
            >{{ showMore ? '收起' : '展开' }}</div>
            <div
              class="gourmet-info-title gourmet-info-titles"
              v-if="detailData.recomDishesVo.length > 0"
            >推荐菜</div>
          </div>
          <div class="gourmet-info-scroll" v-if="detailData.recomDishesVo.length > 0">
            <template v-for="(item, index) in detailData.recomDishesVo">
              <div class="gourmet-info-item" :key="index">
                <div class="gourmet-info-item-img">
                  <img :src="item.img" alt />
                </div>
                <div class="gourmet-info-item-name">{{ item.name }}</div>
                <div class="gourmet-info-item-bottom">
                  <div class="gourmet-info-item-symbol">￥</div>
                  <div class="gourmet-info-item-price">{{ item.price }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <empty
        v-else
        ref="emptyView"
        :toastTitle="toastTitle"
        :emptyShow="emptyShow"
        :style="{ top: emptyTop }"
      />
    </div>
  </div>
</template>

<script>
import openAppDialog from "@/components/openAppTopDialog.vue";
import Loading from "@/components/loading";
import empty from "@/components/empty.vue";
// eslint-disable-next-line no-irregular-whitespace
import Vue from "vue";
// eslint-disable-next-line no-irregular-whitespace
import { Lazyload } from "vant";

Vue.use(Lazyload);

export default {
  name: "line_list",
  data() {
    return {
      openTitle: "打开天府绿道APP<br/>欣赏更多精彩美食",
      shareId: this.$route.query.id,
      shareType: "",
      toastTitle: "糟糕,数据找不到了",
      emptyShow: false,
      emptyTop: "46px",
      isPageError: false,
      isLoading: true,
      // 视频数组
      videoArr: [],
      // 图片数组
      imgList: [],
      CommentNum: 0, // 评论条数
      commentList: [],
      isVideo: false,
      scenicId: "",
      imgIndex: 0,
      videoIndex: 0,
      detailData: {},
      foldState: true,
      //附近推荐
      aroundTabArray: [],
      aroundData: [],
      allATbArr: [],
      aroundTabActive: 0,
      // 收藏数据对象
      collectObj: {},
      showMore: true,
      showMoreDom: false,
    };
  },
  components: {
    Loading,
    openAppDialog,
    empty,
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name) {
        window.location.reload();
      }
    },
  },
  mounted() {
    this.uid = this.$cookie.get("w_uid") || "";
    this.scenicId = this.$route.query.id;
    this.lat = this.$route.query.lat;
    this.lng = this.$route.query.lng;
    this.getGourmetDetail();
  },
  methods: {
    showApp() {
      this.$refs.openApp.showToast();
    },
    openApp() {
      //打开APP,跳转到APP
      //eslint-disable-next-line
      console.log("openApp()");
    },
    /**
     * 轮播图改变事件
     */
    swiperChange(type, event) {
      this.imgIndex = event;
    },
    /**
     * 获取美食详情数据
     */
    getGourmetDetail() {
      this.$http
        .get(`/appserver/v1/finefood/detailed?id=${this.scenicId}`)
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            this.isLoading = false;
            let tags = [];
            if (resData.tag) {
              tags = resData.tag.split(",");
            }
            resData.tag = tags;
            this.detailData = resData;
            this.$nextTick(() => {
              const desc = document.getElementsByClassName(
                "gourmet-info-introduction"
              )[0];
              if (desc.offsetHeight > 40) {
                this.showMore = false;
                this.showMoreDom = true;
              }
            });
          } else {
            this.isLoading = false;
            this.toastTitle = "糟糕,数据找不到了";
            this.emptyShow = true;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.toastTitle = "网络出错,请稍后再试!";
          this.emptyShow = true;
        });
    },

    /**
     * 跳转至导航页
     */
    toMap(lat, lng, location, address) {
      window.location.href =
        "http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:" +
        lat +
        "," +
        lng +
        ";title:" +
        location +
        ";addr:" +
        address +
        "&key=LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG&referer=myapp";
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.scenicParkDetail {
  .banner_container {
    position: relative;
    width: 100%;
    min-height: 177px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 177px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
  }

  .gourmet-conenter {
    width: 100%;
    padding: 30px 20px 0 20px;
    box-sizing: border-box;
    border-bottom: 5px rgba(216, 216, 216, 0.3) solid;
    .gourmet-title {
      width: 100%;
      font-size: 21px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 29px;
      margin-bottom: 4px;
    }
    .gourmet-subtitle {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
      margin-bottom: 8px;
    }
    .gourmet-tag {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .gourmet-tags {
        padding: 0 4px;
        box-sizing: border-box;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6e5adb;
        line-height: 18px;
        background: rgba(97, 69, 247, 0.15);
        border-radius: 2px;
        margin-right: 4px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .gourmet-per-capita {
      display: flex;
      align-items: center;
      margin-bottom: 19px;
      .gourmet-per-capita-symbol {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(120, 120, 120, 1);
        line-height: 17px;
        margin-right: 2px;
      }
      .gourmet-per-capita-price {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(120, 120, 120, 1);
        line-height: 22px;
        margin-right: 2px;
      }
      .gourmet-per-capita-unit {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(120, 120, 120, 1);
        line-height: 17px;
      }
    }
    .gourmet-conenter-cell {
      padding: 15px 0;
      box-sizing: border-box;
      display: flex;
      align-items: stretch;
      border-top: 2px #eeeeee solid;
      .gourmet-conenter-cell-icon {
        width: 18px;
        height: 18px;
        margin-right: 15px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .gourmet-conenter-cell-content {
        width: 100%;
        display: flex;
        align-items: center;
        .gourmet-conenter-cell-title {
          width: 255px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(120, 120, 120, 1);
          line-height: 20px;
        }
        .gourmet-conenter-cell-right-icon {
          flex: 1;
          width: 20px;
          height: 20px;
          text-align: right;
          position: relative;
          img {
            width: 20px;
            height: 20px;
          }
          &::before {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 2px;
            content: "";
            width: 1px;
            height: 22px;
            background-color: rgba(110, 110, 119, 0.1);
          }
        }
      }
    }
  }
  .gourmet-info {
    width: 100%;
    padding-bottom: 20px;
    box-sizing: border-box;
    .gourmet-info-contenter {
      padding: 30px 20px 0 20px;
      box-sizing: border-box;
      .gourmet-info-title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 28px;
        margin-bottom: 10px;
      }
      .gourmet-info-titles {
        margin-bottom: 20px;
      }
      .show-more {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(46, 186, 115, 1);
        line-height: 15px;
        margin-bottom: 40px;
      }
      .gourmet-info-introduction {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(120, 120, 120, 1);
        line-height: 20px;
        margin-bottom: 10px;
      }
      .gourmet-info-introduction-line2 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .gourmet-info-scroll {
      width: 100%;
      height: 160px;
      overflow-x: scroll;
      display: flex;
      align-items: center;
      &::-webkit-scrollbar {
        display: none;
      }
      .gourmet-info-item {
        width: 150px;
        margin-left: 20px;
        &:last-child {
          padding-right: 20px;
        }
        .gourmet-info-item-img {
          width: 150px;
          height: 100px;
          border-radius: 3px;
          img {
            width: 150px;
            height: 100px;
          }
          margin-bottom: 8px;
        }
        .gourmet-info-item-name {
          margin-bottom: 6px;
          width: 150px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(38, 38, 38, 1);
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .gourmet-info-item-bottom {
          display: flex;
          align-items: flex-end;
        }
        .gourmet-info-item-symbol {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 155, 36, 1);
          line-height: 12px;
        }
        .gourmet-info-item-price {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(255, 155, 36, 1);
          line-height: 16px;
        }
      }
    }
  }
}
</style>
